import type { Json } from "@/integrations/supabase/types";
export type BannerFormat = "photo" | "artwork";
export type PhotoFit = "contain" | "cover";
export interface BannerPresentation {
  format: BannerFormat;
  fit: PhotoFit;
  desktop: { x: number; y: number };
  mobile: { x: number; y: number };
}
const record = (value: unknown): Record<string, unknown> => value !== null && typeof value === "object" && !Array.isArray(value) ? value as Record<string, unknown> : {};
const coordinate = (value: unknown) => typeof value === "number" && Number.isFinite(value) ? Math.max(0, Math.min(100, value)) : 50;
export function readBannerPresentation(value: unknown): BannerPresentation {
  const settings = record(record(value).presentation);
  const desktop = record(settings.desktop), mobile = record(settings.mobile);
  return {
    format: settings.format === "artwork" ? "artwork" : "photo",
    // Preserve all product details by default. Cropping is an explicit editor choice.
    fit: settings.fit === "cover" ? "cover" : "contain",
    desktop: { x: coordinate(desktop.x), y: coordinate(desktop.y) },
    mobile: { x: coordinate(mobile.x), y: coordinate(mobile.y) },
  };
}
export function withBannerPresentation(value: unknown, presentation: BannerPresentation): { [key: string]: Json } {
  return { ...record(value) as Record<string, Json>, presentation: {
    format: presentation.format, fit: presentation.fit,
    desktop: { ...presentation.desktop }, mobile: { ...presentation.mobile },
  } };
}
export function bannerWording(banner: object, key: string, language: "en" | "ar") {
  const value = record(banner)[language === "ar" ? `${key}_ar` : key];
  return typeof value === "string" ? value : "";
}
export function bannerShowsWebsiteText(value: unknown) {
  return readBannerPresentation(value).format === "photo";
}